import { Button } from '@/components/Common';
import { Header } from '@/components/Layout/Header/Header';
import { ViewConfigExam } from '@/components/Views/BlankExam/ViewConfigExam';
import { PATHS } from '@/routes/routes.types';
import { useNavigate } from 'react-router-dom';
export const BlankExam = () => {
  const navigate = useNavigate();
  const goToSettingUpTests = () => {
    navigate(PATHS.SETTING_UP_TESTS);
  };
  return (
    <>
      <Header title="Examen Blanc" />
      <div className="w-full">
        <div className="flex items-center py-8">
          <h1 className="text-white text-2xl font-bold">
            Configurer les epreuves
          </h1>
          <Button
            title="Configurer"
            className="ml-[165px]"
            onClick={goToSettingUpTests}
          />
        </div>

        <ViewConfigExam />
      </div>
    </>
  );
};
